<template>
<div class="login-container">
  <div class="login-left">
    <div class="left-top">
      <img src="~assets/logo_blue.png" alt="">
    </div>
    <div class="center-container">
      <el-form class="form-container" :model="ruleLogin" :rules="rules" ref="ruleLogin" status-icon @submit.native.prevent>
        <el-form-item label="账号" prop="account" class="input-list">
          <el-input type="text" v-model="ruleLogin.account" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" class="input-list">
          <el-input type="password" v-model="ruleLogin.password" placeholder="请输入密码" ></el-input>
        </el-form-item>
        <el-form-item class="btn-list">
          <el-button type="primary" class="login-btn"  @click="submitForm('ruleLogin')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div class="login-right">
    <!-- <img src="~assets/login_bg.png" alt=""> -->
      <div class="center-container">
        <p class="right-title">中策计量服务平台 </p>
        <ul class="txt-container">
          <li class="txt-list">费用公开透明</li>
          <li class="txt-list">在线查阅证书</li>
          <li class="txt-list">24小时内免费取件</li>
          <li class="txt-list">全国快递送件</li>
        </ul>
        <p class="link-btn" to="/home">了解详情</p>
      </div>
  </div>
</div>
</template>

<script type='text/ecmascript-6'>
import md5 from 'md5'
import { accountRule, passwordRule} from 'common/js/loginValidate'
import { setCookie } from 'common/js/mUtils' //setStore
export default {
  data () {
    return {
      ruleLogin: {
        accout: '',
        password: ''
      },
      rules: {
        account: [
          { validator: accountRule, trigger: 'blur'}
        ],
        password: [
          { validator: passwordRule, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      /* setCookie('u_uuid_userId','ffgg')
      console.log('uuIid') */
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.login({
            user_name: this.ruleLogin.account,
            passwd: md5(this.ruleLogin.password)
          }).then(res => {
            console.log(res)
            if (res.data.msg === true) {
              setCookie('u_uuid_userId', res.data.user_id)
              // setStore('user_type', res.data.type)
              /* if (res.data.type == 128) {
                this.$router.replace('/markPeople')
              }
              if (res.data.type == 1 || res.data.type == 5) {
                this.$router.replace('/markCustomer')
              }
              if (res.data.type == 2) {
                this.$router.replace('/engineerOrder')
              } */
              this.$router.replace('/uncollectedOrder')
            } else {
              this.$message({
                type: 'error',
                message: '账号或者密码错误',
                customClass: 'msg-position',
                showClose: true
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style  lang='stylus' rel='stylesheet/stylus'>
@import "~common/stylus/mixin.styl"
@import '~common/stylus/input.styl'
  .login-container
    position:fixed;
    top:0px;
    right:0px;
    left:0px;
    bottom:0px;
    display:flex;
    background: #F2F4F6;
    .login-left
      flex:1;
      position:relative;
      .left-top
        padding: 0.8rem 1rem;
        box-sizing:border-box;
        background:#fff;
        img
          height:1.8rem;
      .center-container
        width:100%;
        height:100%;
        display:flex;
        justify-content: center;
        align-items: center;
        .form-container
          width:15rem;
          .input-list
            &.is-error
              .el-form-item__content
                .el-input
                  .el-input__inner
                    border: 0.05rem solid #EF757A;
            .el-form-item__label
              color:#333;
              font-size:0.8rem
              font-weight: Medium;
            .el-form-item__content
              position:relative;
              height:4rem;
              .el-input
                height:2rem;
                .el-input__inner
                  padding: 0 0.8rem;
              .el-form-item__error
                /* top:2.5rem; */
                left: 0.8rem;
                background:#fff;
                color:#EF757A;
          .btn-list
            width:100%;
            margin:0;
            .el-form-item__content
              .login-btn
                background:#1D489E;
                padding: 0.65rem 1.8rem;
                span
                  color:#fff;
    .login-right
      flex:1;
      position:relative;
      height:100%;
      bg-image('~assets/login_bg.png');
      background-size:100% 100%;
      background-repeat: no-repeat;
      .center-container
        position:absolute;
        color:#fff;
        width:300px;
        left:50%;
        top:50%;
        margin-left:-150px;
        margin-top:-100px
        .right-title
          font-size: 32px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 40px;
          font-weight:bold;
          width:100%;
          text-align:center;
        .txt-container
          margin-top:40px;
          .txt-list
            font-size: 16px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            line-height: 30px;
        .link-btn
          background: #FFFFFF;
          border-radius: 4px;
          line-height:40px;
          height:40px;
          display:block;
          width:160px;
          margin:40px auto 0px auto;
          text-align:center;
          font-size: 14px;
          color: #193B83;
          letter-spacing: 0;
</style>
